<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 1
      h1 Desarrollo personal y autoconocimiento

    .row.align-items-center
      .col-lg-4.d-none.d-lg-block
        figure(data-aos="fade-right")
          img(src='@/assets/curso/tema1/1.png', alt='', style="width: 100%")
      .col-lg-8
        .row.justify-content-center
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color1.p-4
                  p El desarrollo personal es un proceso continuo mediante el cual las personas fortalecen sus capacidades, conocimientos y habilidades con el propósito de mejorar su bienestar, su desempeño en la sociedad y su relación con los demás. Este proceso implica reconocer las propias fortalezas, identificar aspectos que pueden mejorar y asumir una actitud de aprendizaje permanente frente a los retos de la vida personal, social y laboral. En el contexto actual, caracterizado por cambios constantes y dinámicos, el desarrollo personal se convierte en una herramienta fundamental para adaptarse a nuevas situaciones, tomar decisiones responsables y construir proyectos de vida significativos

        p.mt-3 El autoconocimiento es uno de los pilares fundamentales del desarrollo personal, ya que permite a las personas comprender quiénes son, cuáles son sus valores, intereses, emociones y formas de actuar frente a diferentes situaciones. Conocerse a sí mismo facilita la identificación de fortalezas que pueden potenciarse y de aspectos que requieren fortalecimiento para mejorar la interacción con los demás. Cuando una persona desarrolla un mayor nivel de autoconocimiento, logra comprender mejor sus reacciones emocionales, sus motivaciones y sus metas, lo que contribuye a una mayor claridad en la toma de decisiones.


    .row.align-items-center.mt-4
      .col-lg-8
        .row.align-items-start.mt-4
          .col-lg-2.mb-lg-0.mb-4
            figure(data-aos="fade-down")
              img(src='@/assets/curso/tema1/2.svg', style='width: 100px').m-auto
          
          .col
            p En el ámbito personal y laboral, el autoconocimiento también favorece el desarrollo de competencias blandas como la empatía, la comunicación asertiva y la capacidad de trabajo en equipo. Comprender las propias emociones y reconocer cómo influyen en el comportamiento permite establecer relaciones interpersonales más respetuosas y constructivas. Además, el autoconocimiento facilita la identificación de creencias limitantes o patrones de comportamiento que pueden afectar el crecimiento personal, permitiendo transformarlos en oportunidades de aprendizaje y mejora continua.

        p.mt-2 Promover el desarrollo personal y el autoconocimiento contribuye a la construcción de individuos más conscientes de su papel en la sociedad. A continuación, se presentan cuatro elementos que evidencian el impacto de este proceso en el crecimiento individual y en el bienestar colectivo.

      .col-lg-4.d-none.d-lg-block
        figure(data-aos="fade-right")
          img(src='@/assets/curso/tema1/3.svg', alt='', style="width: 100%")
      
    .row.align-items-center.mt-4
      .col-lg-4.d-none.d-lg-block
        figure(data-aos="fade-right")
          img(src='@/assets/curso/tema1/4.png', alt='', style="width: 100%")
      .col-lg-8
        TabsA.color-acento-botones
          .tarjeta.clr-paleYellow.p-4(titulo="La conciencia social")
            p Desarrollar el autoconocimiento permite que las personas reconozcan su papel en la sociedad y comprendan de qué manera sus acciones pueden generar cambios positivos en el entorno que las rodea.
          .tarjeta.clr-paleYellow.p-4(titulo="La autoestima")
            p A través de procesos de reflexión, aprendizaje y práctica, las personas fortalecen la confianza en sí mismas y consolidan una imagen personal más sólida que les permite enfrentar los desafíos cotidianos con mayor seguridad.

          .tarjeta.clr-paleYellow.p-4(titulo="La actitud proactiva")
            p El desarrollo personal favorece una disposición activa frente a los retos de la vida. Las personas que trabajan en su crecimiento asumen los desafíos como oportunidades y participan de manera más efectiva en espacios de convivencia y colaboración.

          .tarjeta.clr-paleYellow.p-4(titulo="El bienestar colectivo")
            p El crecimiento individual trasciende la esfera personal e impacta directamente en la comunidad. Las personas que desarrollan sus competencias personales contribuyen a la construcción de entornos más solidarios, participativos y orientados al bien común.
        
    p.mt-4 Para comprender mejor el proceso de desarrollo personal y autoconocimiento, en la tabla 1 se presentan algunos de los elementos fundamentales que intervienen en este proceso. El autoconocimiento permite reconocer aspectos internos que influyen en la manera en que las personas piensan, sienten y actúan en diferentes contextos de la vida cotidiana, y cuya comprensión resulta clave para el fortalecimiento del desarrollo personal y las relaciones interpersonales.

    .row.justify-content-center
      .col-lg-12
        .titulo-sexto.color-acento-contenido.mb-3.mt-4
          h5 Tabla 1.
          span Elementos del desarrollo personal y autoconocimiento

        .tabla-a.color-acento-contenido
          table
            thead(style="background-color: #A0F7FE")
              tr
                th(style="width: 300px;") Elemento
                th Descripción
                th Importancia en el desarrollo personal
            tbody
              tr(style="background-color: #F6F6F6")
                th.text-start Fortalezas personales
                td.text-start Son las habilidades, talentos o capacidades que una persona posee y que le permiten desempeñarse de manera efectiva en diferentes situaciones.
                td.text-start Permiten potenciar el crecimiento personal y aprovechar mejor las oportunidades en el ámbito personal y laboral.
              tr
                th.text-start Oportunidades de mejora
                td.text-start Son aquellos aspectos del comportamiento, habilidades o conocimientos que pueden fortalecerse mediante el aprendizaje y la práctica.
                td.text-start Facilitan el proceso de mejora continua y contribuyen al desarrollo de nuevas competencias.

              tr(style="background-color: #F6F6F6")
                th.text-start Valores personales
                td.text-start Son principios o creencias que orientan el comportamiento y las decisiones de una persona en su vida diaria.
                td.text-start Ayudan a actuar con coherencia, responsabilidad y respeto en las relaciones con los demás.
              tr
                th.text-start Emociones
                td.text-start Son respuestas internas que experimentan las personas frente a diferentes situaciones o estímulos del entorno.
                td.text-start Comprender las emociones permite gestionarlas adecuadamente y mejorar la interacción social.

              tr(style="background-color: #F6F6F6")
                th.text-start Creencias personales
                td.text-start Son ideas o percepciones que una persona tiene sobre sí misma, sobre los demás y sobre el mundo que la rodea.
                td.text-start Influyen en la forma de actuar, tomar decisiones y enfrentar los desafíos de la vida.

    separador
    #t_1_1.titulo-segundo.color-acento-contenido
      h2 1.1 Concepto de desarrollo personal

    p El desarrollo personal se entiende como el proceso mediante el cual una persona fortalece sus capacidades, conocimientos, habilidades y actitudes con el propósito de mejorar su calidad de vida y su desempeño en los diferentes ámbitos en los que interactúa. Este proceso implica una reflexión constante sobre las propias experiencias, el reconocimiento de las fortalezas individuales y la identificación de aspectos que pueden mejorarse. En este sentido, el desarrollo personal no es un evento aislado, sino un proceso continuo que acompaña a las personas a lo largo de toda su vida.

    .row.align-items-center.justify-content-center
      .col-lg-12
        .row.justify-content-center.mt-4
          .col-lg-12(data-aos="fade-down")
            .row.d-flex.align-items-center.bg-base(data-aos="fade-right")
              .col-lg-auto.pe-lg-0.mb-4.mb-xl-0.d-flex.d-none.d-lg-block
                figure.m-0.p-0.w-100.h-100.d-flex
                  img(src='@/assets/curso/tema1/5.png', alt='', class="w-100 h-100 object-fit-cover", style="margin-left:-12px")
              .col-lg
                figure
                  img(src="@/assets/curso/tema1/27.svg", alt="", style="width: 80px")

                p.mt-4.text-white Desde una perspectiva integral, el desarrollo personal abarca diferentes dimensiones del ser humano, entre ellas la dimensión emocional, social, cognitiva y ética. Estas dimensiones influyen en la manera en que las personas interpretan la realidad, toman decisiones y se relacionan con los demás. Cuando una persona trabaja en su desarrollo personal, busca fortalecer estas dimensiones para actuar de manera más consciente, responsable y coherente frente a los desafíos de su entorno.


    .row.align-items-center.justify-content-center
      .col-lg-10
        .row.align-items-center.mt-4
          .col-lg-2.mb-lg-0.mb-4
            figure(data-aos="fade-down")
              img(src='@/assets/curso/tema1/6.svg', style='width: 84px').m-auto
          
          .col
            p En el ámbito educativo y laboral, el desarrollo personal adquiere una gran relevancia, ya que permite a las personas adaptarse a contextos cambiantes, asumir nuevos retos y participar activamente en procesos de trabajo colaborativo. Las organizaciones y las comunidades valoran cada vez más a las personas que demuestran iniciativa, capacidad de aprendizaje, habilidades para comunicarse y disposición para mejorar continuamente.

        .row.justify-content-center.mt-4
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color1.p-4
                  p Las organizaciones y las comunidades valoran cada vez más a las personas que demuestran iniciativa, capacidad de aprendizaje y disposición para mejorar continuamente, cualidades que se fortalecen cuando cada individuo reconoce sus capacidades y asume un compromiso consciente con su propio crecimiento.

        .row.align-items-center.mt-4
          .col-lg-4
            figure(data-aos="fade-right")
              img(src='@/assets/curso/tema1/7.svg', alt='', style="width: 100%")
          .col-lg-8
            p Por esta razón, el desarrollo personal se relaciona directamente con el fortalecimiento de las competencias blandas, las cuales son fundamentales para la convivencia, la cooperación y la resolución de problemas.

            p Asimismo, el desarrollo personal está estrechamente vinculado con el autoconocimiento, ya que comprender las propias emociones, valores y motivaciones facilita la construcción de metas claras y la toma de decisiones acertadas. Cuando una persona reconoce sus capacidades y asume un compromiso con su crecimiento, puede orientar sus acciones hacia el logro de objetivos personales y profesionales. De esta manera, el desarrollo personal se convierte en una herramienta clave para construir proyectos de vida significativos y contribuir positivamente al bienestar individual y colectivo.

    p.mt-4 A continuación, se describe una secuencia de pasos que orienta la comprensión del proceso de desarrollo personal. Este esquema permite identificar las etapas fundamentales mediante las cuales cada persona puede fortalecer su crecimiento individual de manera progresiva y consciente.

    .row.bg-05.mb-5
      .col-12
        .p-5
          .row.align-items-center.p-5
            .tarjeta.bg-9.p-4
              PasosB.color-acento-contenido
                //-Primer Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema1/8.png', alt='')
                    
                  .col-md-6
                    h4 Paso 1. Reconocer quién es la persona
                    p El desarrollo personal comienza cuando cada individuo reflexiona sobre sí mismo, identifica sus características, intereses, valores, emociones y metas. Este reconocimiento permite tener mayor claridad sobre la manera en que actúa y se relaciona con los demás.

                //-Segundo Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema1/9.png', alt='')
                    
                  .col-md-6
                    h4 Paso 2. Identificar fortalezas y aspectos por mejorar

                    p Después del reconocimiento personal, es importante analizar cuáles son las habilidades, capacidades y actitudes que favorecen el crecimiento, así como aquellos aspectos que requieren fortalecimiento. Este ejercicio permite establecer un punto de partida para el mejoramiento continuo.

                //-Tercer Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema1/10.png', alt='')
                    
                  .col-md-6
                    h4 Paso 3. Comprender la importancia del cambio y el aprendizaje

                    p El desarrollo personal implica asumir una actitud abierta al aprendizaje, al cambio y a la superación de dificultades. Comprender que siempre es posible mejorar ayuda a fortalecer la confianza, la motivación y la disposición para enfrentar nuevos retos.
                    
              
                //-Cuarto Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema1/11.png', alt='')
                    
                  .col-md-6
                    h4 Paso 4. Definir metas de crecimiento personal

                    p Una vez identificadas las fortalezas y oportunidades de mejora, la persona puede establecer objetivos concretos que orienten su crecimiento. Estas metas pueden relacionarse con el manejo de emociones, la comunicación, la convivencia o el desempeño en el entorno laboral y social.

                //-Cuarto Paso
                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema1/12.png', alt='')
                    
                  .col-md-6
                    h4 Paso 5. Aplicar acciones de mejora en la vida cotidiana

                    p El desarrollo personal no se limita a la reflexión teórica; requiere llevar a la práctica acciones que favorezcan el cambio positivo. Por ello, es necesario aplicar hábitos, conductas y estrategias que permitan mejorar progresivamente en los distintos contextos de la vida.

                .row(titulo="")
                  .col-md-6.mb-4.mb-md-0
                    figure
                      img(src='@/assets/curso/tema1/13.png', alt='')
                    
                  .col-md-6
                    h4 Paso 6. Evaluar avances y mantener el proceso

                    p El desarrollo personal es un proceso continuo, por lo que es importante revisar periódicamente los avances logrados, reconocer los aprendizajes obtenidos y ajustar las acciones cuando sea necesario. De esta manera, la persona fortalece su crecimiento de forma permanente y consciente.

    separador
    #t_1_2.titulo-segundo.color-acento-contenido
      h2 1.2 Importancia del autoconocimiento en el crecimiento humano


    p El autoconocimiento es un elemento fundamental para el crecimiento humano, ya que permite a las personas comprender sus emociones, pensamientos, valores y comportamientos en diferentes contextos de la vida. Cuando una persona desarrolla la capacidad de reflexionar sobre sí misma, puede identificar sus fortalezas, reconocer sus limitaciones y tomar decisiones más conscientes frente a los retos que enfrenta. En este sentido, el autoconocimiento se convierte en una herramienta clave para orientar el desarrollo personal y construir relaciones más saludables con los demás. 

    .row.justify-content-center.mt-4
      .col-lg-10
        .row.bg-base4.p-4
          .bloque-texto-f.bg-base4.pt-4.px-5
            .bloque-texto-f__comillas
              i.fas.fa-quote-left
              i.fas.fa-quote-right
            h4.bloque-texto-f__texto El conocimiento de las propias emociones y de la forma en que estas influyen en el comportamiento es un aspecto esencial para promover el bienestar personal y social.
            p - Bisquerra, 2009

    .bloque-texto-g.bloque-texto-g--inverso.bg-base.p-3.p-sm-4.p-md-5.mt-4
      .bloque-texto-g__img(
        :style="{'background-image': `url(${require('@/assets/curso/tema1/14.png')})`}"
      )
      .bloque-texto-g__texto.p-4
        p.mb-0 El autoconocimiento también favorece la construcción de una identidad personal más sólida, lo que permite a las personas actuar con mayor coherencia entre lo que piensan, sienten y hacen. Este proceso implica reconocer las propias motivaciones, metas y valores, aspectos que influyen directamente en la manera en que se toman decisiones y se enfrentan las dificultades. La capacidad de reconocer las propias emociones y comprender su impacto en el comportamiento constituye uno de los componentes centrales de la inteligencia emocional, la cual incide de manera significativa en el desarrollo personal y en la calidad de las relaciones interpersonales (Goleman, 2013).


    .row.align-items-center.justify-content-center.mt-4
      .col-lg-5.d-none.d-lg-block
        figure(data-aos="fade-right")
          img(src='@/assets/curso/tema1/15.png', alt='', style="width: 100%")
      .col-lg-7
        p Desde la perspectiva del desarrollo humano y organizacional, el autoconocimiento también se relaciona con la capacidad de las personas para adaptarse a contextos cambiantes, aprender de la experiencia y fortalecer sus competencias personales y sociales. En los entornos laborales actuales, las organizaciones valoran cada vez más a las personas que demuestran conciencia de sí mismas, habilidades de comunicación y disposición para el aprendizaje continuo. El crecimiento personal comienza con la capacidad de mirarse a sí mismo con honestidad, reconocer los propios hábitos y asumir la responsabilidad de transformarlos para alcanzar un mayor nivel de efectividad personal (Covey, 2005).

        .row.justify-content-center
          .col-lg-12
            .row.align-items-center
              .col-lg-12
                .cajon.color3.p-4
                  p El autoconocimiento contribuye a fortalecer la autoestima, la seguridad personal y la capacidad de relacionarse de manera respetuosa y empática con otras personas. Comprender las propias emociones, valores y formas de actuar permite mejorar la comunicación, prevenir conflictos y promover ambientes de convivencia más positivos.

    p.mt-4 Cuando las personas desarrollan una mayor conciencia de sí mismas, amplían su capacidad de interpretar la realidad y de generar nuevas posibilidades de acción en su vida personal y social (Echeverría, 2011). Por esta razón, el autoconocimiento se considera uno de los pilares fundamentales para el crecimiento humano y el desarrollo de competencias blandas en los diferentes ámbitos de la vida.


    separador
    #t_1_3.titulo-segundo.color-acento-contenido
      h2 1.3 Identificación de fortalezas y oportunidades de mejora

    p La identificación de fortalezas y oportunidades de mejora contribuye a fortalecer el autoconocimiento y la toma de decisiones responsables. Comprender las capacidades que se poseen y los aspectos que requieren fortalecimiento permite orientar los esfuerzos hacia el desarrollo de competencias que favorezcan el bienestar individual y colectivo. Este proceso se convierte en una herramienta valiosa para mejorar la interacción con los demás y participar de manera más efectiva en distintos espacios de convivencia y colaboración. A continuación, se presentan los elementos esenciales que conforman este proceso:


    .row.align-items-center.justify-content-center.mt-4
      .col-lg-12
        SlyderF(columnas="col-lg-6 col-xl-4")
          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema1/16.svg', style="width: 128px").m-auto
            p.text-center
              b Fortalezas personales
            p.text-center.mb-0 Habilidades, conocimientos y actitudes que permiten desempeñarse de manera efectiva en diferentes situaciones de la vida cotidiana y laboral. 
                  
          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema1/17.svg', style="width: 128px").m-auto
            p.text-center
              b Oportunidades de mejora
            p.text-center.mb-0 Aspectos del comportamiento, las habilidades o los conocimientos que pueden fortalecerse mediante el aprendizaje, la práctica y la reflexión continua.

          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema1/18.svg', style="width: 128px").m-auto
            p.text-center
              b Aprendizaje permanente
            p.text-center.mb-0 Actitud que favorece la capacidad de analizar las experiencias vividas y reconocer los errores como oportunidades de crecimiento personal y profesional. 


          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema1/19.svg', style="width: 128px").m-auto
            p.text-center
              b Autoconocimiento
            p.text-center.mb-0 Proceso que fortalece la toma de decisiones responsables y permite orientar los esfuerzos hacia el desarrollo de competencias que favorezcan el bienestar individual y colectivo. 


          .tarjeta.bg-04.p-4.text-white
            .row.justify-content-center.mb-3
              .col-8
                img(src='@/assets/curso/tema1/20.svg', style="width: 128px").m-auto
            p.text-center
              b Metas de crecimiento
            p.text-center.mb-0 Objetivos concretos y realistas que se establecen a partir de la identificación consciente de las propias capacidades y de los aspectos que requieren fortalecimiento.
    

    .row.justify-content-center.mt-4
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color1.p-4
              p En este sentido, el proceso de identificación de fortalezas implica reconocer aquellas capacidades que favorecen el logro de objetivos y el desarrollo de relaciones interpersonales positivas. Estas pueden manifestarse en habilidades como la comunicación, la empatía, la responsabilidad o la capacidad para trabajar en equipo. Al mismo tiempo, identificar oportunidades de mejora permite comprender que el desarrollo personal es un proceso continuo en el que siempre existen aspectos que pueden perfeccionarse para mejorar el desempeño en diferentes contextos sociales y laborales.



        .row.align-items-center.mt-4
          .col-lg-4
            figure(data-aos="fade-right")
              img(src='@/assets/curso/tema1/21.png', alt='', style="width: 100%")
          .col-lg-8
            .row.align-items-start.mt-4
              .col-lg-2.mb-lg-0.mb-4
                figure(data-aos="fade-down")
                  img(src='@/assets/curso/tema1/22.svg', style='width: 100px').m-auto
              
              .col
                p Por otra parte, reflexionar sobre las propias fortalezas y oportunidades de mejora favorece el desarrollo de una actitud de aprendizaje permanente. Este ejercicio promueve la capacidad de analizar las experiencias vividas, reconocer los errores como oportunidades de aprendizaje y fortalecer la confianza en las propias capacidades. Cuando las personas asumen este proceso de manera consciente, pueden establecer metas realistas y diseñar acciones que contribuyan a su crecimiento personal y profesional.

            p En consecuencia, la identificación de fortalezas y oportunidades de mejora contribuye a fortalecer el autoconocimiento y la toma de decisiones responsables. Comprender cuáles son las capacidades que se poseen y qué aspectos requieren fortalecimiento permite orientar los esfuerzos hacia el desarrollo de competencias que favorezcan el bienestar individual y colectivo. Este proceso se convierte en una herramienta valiosa para promover el crecimiento humano, mejorar la interacción con los demás y participar de manera más efectiva en diferentes espacios de convivencia y colaboración.


    separador
    #t_1_4.titulo-segundo.color-acento-contenido
      h2 1.4 Creencias limitantes y creencias potenciadoras

    p Las creencias son ideas o interpretaciones que las personas construyen a partir de sus experiencias, aprendizajes y del entorno en el que se desarrollan. Estas creencias influyen en la manera en que cada individuo percibe la realidad, toma decisiones y enfrenta los diferentes desafíos de la vida. En el proceso de desarrollo personal, comprender el papel de las creencias resulta fundamental, ya que muchas de ellas pueden fortalecer el crecimiento individual, mientras que otras pueden limitar el potencial y las posibilidades de acción de las personas.

    .row.justify-content-center.mt-4
      .col-lg-10
        .row.align-items-center
          .col-lg-12
            .cajon.color3.p-4
              p En el proceso de desarrollo personal, las creencias desempeñan un papel fundamental, ya que orientan la manera en que cada persona percibe la realidad, toma decisiones y enfrenta los desafíos cotidianos. Estas ideas pueden fortalecer el crecimiento individual o limitarlo, dependiendo de la forma en que influyen en el comportamiento y en la actitud frente al aprendizaje. A continuación, se presentan los dos tipos de creencias que intervienen en este proceso.


    .row.justify-content-center.mt-4
      .col-lg-12
        AcordionA.mb-5(tipo="a" clase-tarjeta="tarjeta bg-1")
          .tarjeta.clr--pink02.p-4(titulo="Las creencias limitantes")
            .row.align-items-center
              .col-lg-6
                p Son aquellas ideas que restringen la capacidad de una persona para avanzar, aprender o asumir nuevos retos. Este tipo de creencias suele estar asociado a pensamientos negativos sobre las propias capacidades, como considerar que no se tiene el talento suficiente para realizar una tarea o que no es posible lograr determinados objetivos. Cuando estas ideas se mantienen sin cuestionamiento, pueden afectar la confianza personal, disminuir la motivación y generar temor frente a situaciones nuevas o desafiantes.

              .col-lg-6
                figure(data-aos="fade-right")
                  img(src='@/assets/curso/tema1/23.png', alt='', style="width: 100%")
    
          div(titulo="Las creencias potenciadoras")
            .row.align-items-center
              .col-lg-6
                p Son aquellas que impulsan el crecimiento personal y favorecen una actitud positiva frente al aprendizaje y el cambio. Este tipo de creencias permite que las personas reconozcan sus capacidades, confíen en su potencial y asuman los retos como oportunidades para mejorar. Al fortalecer este tipo de pensamientos, se promueve una mentalidad orientada al desarrollo, en la que los errores se interpretan como experiencias de aprendizaje y no como fracasos definitivos.

              .col-lg-6
                figure(data-aos="fade-right")
                  img(src='@/assets/curso/tema1/24.png', alt='', style="width: 100%") 


    .row.align-ites-center.mt-4
      .col-lg-5.d-none.d-lg-block
        figure(data-aos="fade-right")
          img(src='@/assets/curso/tema1/25.png', alt='', style="width: 100%")
      .col-lg-7
        p En consecuencia, reconocer y analizar las propias creencias es un paso importante dentro del proceso de autoconocimiento y desarrollo personal. Al identificar aquellas ideas que limitan el crecimiento, las personas pueden transformarlas gradualmente en creencias que impulsen su progreso y bienestar. De esta manera, trabajar en la construcción de creencias potenciadoras contribuye a fortalecer la confianza, la motivación y la capacidad para enfrentar los desafíos de la vida personal, social y laboral.

        .row.align-items-start.mt-4
          .col-lg-2.mb-lg-0.mb-4
            figure(data-aos="fade-down")
              img(src='@/assets/curso/tema1/26.svg', style='width: 100px').m-auto
          
          .col
            p A continuación, en la tabla 2, se presentan algunos ejemplos de creencias que pueden influir en la forma en que las personas enfrentan los desafíos personales y profesionales. Las creencias limitantes suelen generar inseguridad o miedo al cambio, mientras que las creencias potenciadoras promueven el aprendizaje, la confianza y el crecimiento personal.


    .row.justify-content-center
      .col-lg-10
        .titulo-sexto.color-acento-contenido.mb-3.mt-4
          h5 Tabla 2.
          span Ejemplos de creencias limitantes y creencias potenciadoras

        .tabla-a.color-acento-contenido
          table
            thead(style="background-color: #A0F7FE")
              tr
                th Creencias limitantes
                th Creencias potenciadoras
            tbody
              tr(style="background-color: #F6F6F6")
                td.text-start No soy capaz de aprender cosas nuevas.
                td.text-start Puedo aprender nuevas habilidades si practico y me esfuerzo.
              tr
                td.text-start Siempre me equivoco cuando intento algo diferente.
                td.text-start Los errores son oportunidades para aprender y mejorar.

              tr(style="background-color: #F6F6F6")
                td.text-start No tengo habilidades para comunicarme con los demás.
                td.text-start Puedo mejorar mi comunicación con práctica y disposición para aprender.
              tr
                td.text-start No soy bueno trabajando en equipo.
                td.text-start Puedo desarrollar habilidades para colaborar con otras personas.

              tr(style="background-color: #F6F6F6")
                td.text-start Es demasiado tarde para cambiar o mejorar.
                td.text-start Siempre es posible aprender y mejorar en cualquier etapa de la vida.
              tr
                td.text-start Si fracaso una vez significa que no soy capaz.
                td.text-startt Cada intento me acerca más al logro de mis objetivos.

              tr(style="background-color: #F6F6F6")
                td.text-start No tengo talento suficiente para lograr mis metas.
                td.text-start Con disciplina y aprendizaje constante, puedo alcanzar mis metas.
              tr
                td.text-start No puedo controlar mis emociones.
                td.text-start Puedo aprender a reconocer y gestionar mis emociones.

              tr(style="background-color: #F6F6F6")
                td.text-start Las cosas siempre me salen mal.
                td.text-start Puedo aprender de las experiencias y mejorar mis resultados.
              tr
                td.text-start Los cambios son negativos y difíciles.
                td.text-start Los cambios pueden representar oportunidades de crecimiento.



</template>

<script>
export default {
  name: 'Tema1',
  data: () => ({
    mostrarIndicadorTarjetaAudio: true,
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
